import React from "react";

function IndustryCard({ title, description, features, img, icon }) {
  return (
    <div className="col-12 col-md-6 col-lg-3 mb-4">
      <div className="h_270x w-100 br_10 overflow-hidden industryCardMain position-relative">
        <div className="position-relative w-100 h-100">
          <img
            className="position-absolute w-100 h-100 object-fit-cover"
            src={img}
            alt={title}
          />
          <div className="d-flex flex-column h-100 p-3 position-relative z-5">
            <div className="d-flex justify-content-between align-items-center position-relative zi_10">
              <img src={icon} alt={title} />
              <div className="w_40x h_40x cardIndustryIconHead rounded-circle d-flex justify-content-center align-items-center">
                <i className="fas fa-arrow-right text-white"></i>
              </div>
            </div>
            <div className="align-items-end d-flex h-100 position-relative">
              <div className="position-absolute IndustryCardContent">
                <h3 className="font_17 font_400 text-white">{title}</h3>
                <p className="font_13 text-white mb-0">{description}</p>
              </div>
              <div className="industryHoverContent position-absolute d-flex flex-column gap-3 zi_10">
                {features.map((feature, index) => (
                  <div key={index} className="d-flex align-items-center gap-2">
                    <i className="fas fa-check text_master2 font_10 w_20x h_20x rounded-circle bg-black d-flex align-items-center justify-content-center"></i>
                    <h4 className="font_13 font_500 text-white mb-0">
                      {feature}
                    </h4>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndustryCard;
